import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-overview-meeting-documents',
  templateUrl: './overview-meeting-documents.component.html',
  styleUrls: ['./overview-meeting-documents.component.scss'],
})
export class OverviewMeetingDocumentsComponent implements OnInit {

  @Input() public documents;
  btnIcon: string;

  constructor(public chdRef: ChangeDetectorRef, private utils: UtilsService) { }

  ngOnInit() {
    this.btnIcon = 'download';
    this.chdRef.detectChanges();
  }

  downloadDocument(doc) {
    const media = this.utils.extractStrapiMedia(doc.document);
    if (Capacitor.getPlatform() !== 'web') {
      this.utils.downloadFileNative(media.url, media.ext, doc.title);
    } else {
      this.utils.downloadFile(media.url, media.ext, doc.title);
    }
    this.chdRef.detectChanges();
  }

}
